import { render, staticRenderFns } from "./CiLogoMin.vue?vue&type=template&id=e6904232&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports